import { InfoCircleOutlined } from '@ant-design/icons'
import { Card, Row, Col, Statistic, Progress, Space, Typography, Alert } from 'antd'
import { fmtDateTime } from '../../utils'
import type { ShadowWorkflowSummary, ShadowWorkflowResponse } from '../../types'

interface SummaryCardsProps {
  summary: ShadowWorkflowSummary | undefined
  data: ShadowWorkflowResponse | undefined
  isLoading: boolean
  isFetching: boolean
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  summary,
  data,
  isLoading,
  isFetching
}) => {
  const successRate = summary?.total_executions
    ? Math.round((summary.successful_executions / summary.total_executions) * 100)
    : 0

  return (
    <>
      {summary?.is_stale && (
        <Alert
          type='warning'
          showIcon
          message='Workflow appears stale'
          description={`Last execution was ${summary.hours_since_last} hours ago. Expected daily execution.`}
        />
      )}

      <Row gutter={[16, 16]}>
        <Col xs={24} md={6}>
          <Card className='rounded-2xl'>
            <Statistic
              title='Success Rate (7d)'
              value={successRate}
              suffix='%'
              loading={isLoading || isFetching}
              valueStyle={{
                color: successRate >= 95 ? '#3f8600' : successRate >= 80 ? '#faad14' : '#cf1322'
              }}
            />
            <Progress
              percent={successRate}
              showInfo={false}
              strokeColor={
                successRate >= 95 ? '#3f8600' : successRate >= 80 ? '#faad14' : '#cf1322'
              }
              size='small'
            />
          </Card>
        </Col>
        <Col xs={24} md={6}>
          <Card className='rounded-2xl'>
            <Statistic
              title='Total Executions (7d)'
              value={summary?.total_executions || 0}
              loading={isLoading || isFetching}
            />
          </Card>
        </Col>
        <Col xs={24} md={6}>
          <Card className='rounded-2xl'>
            <Statistic
              title='Total Files Processed (7d)'
              value={summary?.total_files_processed || 0}
              loading={isLoading || isFetching}
            />
          </Card>
        </Col>
        <Col xs={24} md={6}>
          <Card className='rounded-2xl'>
            <Statistic
              title='Failed Executions'
              value={summary?.failed_executions || 0}
              loading={isLoading || isFetching}
              valueStyle={{
                color: (summary?.failed_executions || 0) > 0 ? '#cf1322' : '#3f8600'
              }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card className='rounded-2xl'>
            <Space>
              <InfoCircleOutlined />
              <Typography.Text>
                Monitoring window: {fmtDateTime(data?.range.from)} → {fmtDateTime(data?.range.to)}
              </Typography.Text>
            </Space>
          </Card>
        </Col>
      </Row>
    </>
  )
}
